export default {"src":"/_next/static/media/payment-cartes-bancaires.0db900f4.svg","height":24,"width":36,"blurWidth":0,"blurHeight":0};